import { Component, OnInit,ViewChild  } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import * as firebase from 'firebase';
import{ServicioFechasQueryService} from '../servicio-fechas-query.service'
import {ModalDataUsuarioComponent } from '../modal-data-usuario/modal-data-usuario.component'
import { NgxChartsModule } from '@swimlane/ngx-charts';
import {ServiDataService} from '../servi-data.service'


@Component({
  selector: 'app-componente-data1',
  templateUrl: './componente-data1.component.html',
  styleUrls: ['./componente-data1.component.scss']
})
export class ComponenteData1Component implements OnInit {

  alertaActiva=false
  statuslimpio=true

  dataChart1
  dataChart2
  dataChart3drilling
  dataChart3Produccion
  dataChart3workover
  dataChart3sismica

  dataChart3ProyectosYfacilidades
  dataChart3Logistica
  dataChart3mantenimiento
  dataChartadministracion


  constructor(public serviDataService:ServiDataService, public servicioFechasQueryService:ServicioFechasQueryService, private modalService: NgbModal) { }

  ngOnInit(): void {

  }

  nuevoReporte(){
    this.dataChart1=undefined
    this.dataChart2=undefined
    this.dataChart3drilling=undefined
    this.dataChart3Produccion=undefined
    this.dataChart3workover=undefined
    this.dataChart3sismica=undefined
    this.dataChart3ProyectosYfacilidades=undefined
    this.dataChart3Logistica=undefined
    this.dataChart3mantenimiento=undefined
    this.dataChartadministracion=undefined
    this.statuslimpio=true
  }

  generarReporte(){
    this.alertaActiva=true
    this.statuslimpio=false
    this.serviDataService.queryChart1((RespuestadataChart1,RespuestadataChart2,RespuestadataChart3drilling,RespuestadataChart3Produccion,RespuestadataChart3workover,RespuestadataChart3sismica,RespuestadataChart3ProyectosYfacilidades,RespuestadataChart3Logistica,RespuestadataChart3mantenimiento,RespuestadataChart3administracion)=>{
      this.dataChart1=RespuestadataChart1
      this.dataChart2=RespuestadataChart2
      this.dataChart3drilling=RespuestadataChart3drilling
      this.dataChart3Produccion=RespuestadataChart3Produccion
      this.dataChart3workover=RespuestadataChart3workover
      this.dataChart3sismica=RespuestadataChart3sismica
      this.dataChart3ProyectosYfacilidades=RespuestadataChart3ProyectosYfacilidades
      this.dataChart3Logistica=RespuestadataChart3Logistica
      this.dataChart3mantenimiento=RespuestadataChart3mantenimiento
      this.dataChartadministracion=RespuestadataChart3administracion
      this.alertaActiva=false
    })
  }



//GRAFICAS:
// Pendiente de aprobación
// Aprobado
// Denegado
// cerrado
// revalidacionSolicitada

// Putumayo norte
// Putumayo sur
// VMM
// VMM-otros
// Bogota

// Drilling
// Producción
// Workover
// Sísmica
// Proyectos y facilidades
// Logística
// Mantenimiento
// Administración


//DISEÑO CHART 1
  view: any[] = [];
  // options
  showXAxis: boolean = true;
  showYAxis: boolean = true;
  gradient: boolean = false;
  showLegend: boolean = true;
  showXAxisLabel: boolean = true;
  yAxisLabel: string = 'Cuenca';
  showYAxisLabel: boolean = true;
  xAxisLabel: string = 'Porcentaje';

  colorScheme = {
    domain: ['#f8961e', '#90be6d', '#f94144', '#577590','#184e77']
  };

  onSelect(event) {
    console.log(event);
  }


//DISEÑO CHART 2
    viewChart2: any[] = [500, 400];

    // options
    showLegendChart2: boolean = true;
    showLabelsChart2: boolean = true;

    colorSchemeChart2 = {
      domain: ['#577590', '#577590', '#577590', '#577590', '#577590', '#577590']
    };

//DISEÑO CHART 3
  legend: boolean = true;
  legendPosition: string = 'below';


  
}//fin de clase



